// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2ZeQW","detailsBorder":"styles_detailsBorder__3S6du"};